import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import "./styles/index.css";
import { routeTree } from "./routeTree.gen";
import { I18nProvider } from "./lib/i18n";
import { SessionProvider } from "./lib/session";
import { PendingPage } from "./components/Status";

// Router defaults wire the standard status pages so every screen has a
// consistent loading + error + 404 experience. `defaultPendingMs: 250`
// avoids flashing the pending state on fast transitions.
const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPendingMs: 250,
  defaultPendingComponent: PendingPage,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </I18nProvider>
  </StrictMode>,
);
